import { dateFormat } from '@/constant/formats';
import { getDateTime } from '@/lib/helpers/datetime';
import { cn } from '@/lib/utils';
import * as React from 'react';
import Image from 'next/image';

export default function NotificationCard({ nfc, crFrom, localeLang }: any) {
  const idKey =
    nfc?.data &&
    Object.keys(nfc.data).filter((item) => item.includes('_id'))?.[0];

  let idValue = null;
  let linkLabel = 'View';
  if (nfc?.data?.link_label) {
    linkLabel = nfc?.data?.link_label?.[localeLang] ?? nfc?.data?.link_label;
  }
  if (nfc?.data?.link_label && nfc?.data?.[idKey]) {
    idValue = nfc.data[idKey];
    linkLabel = `${
      nfc?.data?.link_label?.[localeLang] ?? nfc?.data?.link_label
    } (${idValue})`;
  }

  let isRead = false;
  if (nfc?.notification_infos?.[0]?.read_at || nfc?.read_at) {
    isRead = true;
  }

  return (
    <>
      <div className={`flex items-center space-x-3`}>
        <div className="">
          {nfc?.data?.media?.image?.[0]?.thum_url ? (
            <div className="relative h-10 w-10">
              <Image
                src={nfc?.data?.media?.image?.[0]?.thum_url}
                alt="NFC image"
                fill
                className="rounded-full object-cover"
                sizes="40px"
              />
            </div>
          ) : null}
        </div>
        <div className="space-y-1">
          <h3 className="text-sm font-medium capitalize text-title">
            {nfc?.data?.title?.[localeLang] || nfc?.data?.title || ''}
          </h3>
          {nfc?.data?.link && crFrom !== 'nfc-popover' && (
            <span
              // href={nfc.data.link}
              // target="_blank"
              className={cn(
                'nfc-item relative mt-1 w-full text-sm font-thin text-primary underline'
              )}
            >
              {linkLabel}
            </span>
          )}
          <div className="text-sm text-gray-500">
            {getDateTime(nfc?.created_at, dateFormat.de)?.full}
          </div>
          {/* <div className="text-gray-500">{getTimeFromNow(nfc?.created_at)}</div> */}
        </div>
      </div>
      {!isRead && (
        <span className=" absolute right-4 top-4">
          <svg
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="3" cy="3" r="3" fill="#F5365C" />
          </svg>
        </span>
      )}
    </>
  );
}
